import {Box, Divider, IconButton, Typography} from "@mui/material";
import {Close} from "@mui/icons-material";
import React from "react";
import BaseModal from "../custom/BaseModal";

const FormModal = (
  {
    open = false,
    onClose,
    title,
    hasDivider = true,
    dividerMb = 2.5,
    children,
    disableBackdropClick = false,
    disableEscapeKeyDown = false,
  }
) => {
  return (
    <BaseModal
      open={open}
      onClose={onClose}
      disableBackdropClick={disableBackdropClick}
      disableEscapeKeyDown={disableEscapeKeyDown}
    >
      <Box display={'flex'}>
        <Box sx={{flexGrow: 1}}>
          <Typography variant='subtitle1' fontWeight={'bold'} mb={1}>{title}</Typography>
        </Box>
        <Box sx={{flexGrow: 0}}>
          <IconButton size={'small'} onClick={onClose} sx={{ml: 2}}>
            <Close sx={{color: '#707070'}}/>
          </IconButton>
        </Box>
      </Box>
      {hasDivider && <Divider sx={{marginBottom: dividerMb}}/>}
      {children}
    </BaseModal>
  )
}

export default FormModal;
